<template>
<div>
    <div class="breadcrumb-list">
        <ol class="breadcrumb">
            <li class="breadcrumb-item active">Attendance Report</li>
        </ol>
    </div>
    <div class="attendance-report">
        <div class="report-head">
            <div class="sub-left-inrgt">
                <div class="shiftdrop-menu-wrp">
                    <span class="shift-opener text-capitalize">
                        <i class="ico ico-fill-circle" :style="{color:roleColor}"></i>
                        <span class="roleName"> Select job type</span>
                    </span>
                    <ul class="shiftdrop-list">
                        <li @click="allEmployeeAfterFilter" style="background: rgb(152, 152, 152);">
                            <i class="ico ico-fill-circle"></i>
                            <span>All</span>
                        </li>
                        <li class="text-capitalize" v-for="(role,rolIndx) of sortedJobRoles" :key="rolIndx" @click="filterByJobType(role.id,role.color,role.name)">
                            <span class="bg-role" :style="{'background':role.color}"></span>
                            <i class="ico ico-fill-circle" v-bind:style="{ color: role.color !== null ? role.color : '',}"></i>
                            <span>{{ role.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="sub-left-inrgt">
                <div class="shiftdrop-menu-wrp">
                    <span class="shift-opener text-capitalize">
                        <span class="statusName" v-text="selectAttendaceStatus">Select Attendance Status</span>
                    </span>
                    <ul class="shiftdrop-list">
                        <li class="text-capitalize hover-bg" v-for="(type,rolIndx) of attendanceTypes" :key="rolIndx" @click="filterAttendanceStatus(type)">
                            <span class="bullet"></span>
                            <span class="textBlack">{{ type }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div>
                <input type="text" class="form-control" placeholder="Search by Name" v-model="search" @keyup="searchByName" />
            </div>

            <div class="report-head-rgt">
                <button type="button" @click="exportxlsx" class="btn btn-outline-primary">Generate CSV</button>
                <ul class="nav nav-tabs tabs-report" role="tablist">
                    <li @click="changeTableId('dayTable')">
                        <a role="tab" data-toggle="tab" href="#inf-day">Day</a>
                    </li>
                    <li @click="changeTableId('weekTable')">
                        <a role="tab" data-toggle="tab" href="#inf-week">Week</a>
                    </li>
                    <li @click="changeTableId('monthTable')">
                        <a class="active" role="tab" data-toggle="tab" href="#inf-month">Month</a>
                    </li>
                </ul>
                <div class="ml-2">
                    <date-picker v-model="dateFilter" value-type="date" format="DD MMM YYYY" lang="en" @change="filterAttendance($event)"></date-picker>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div id="inf-day" class="tab-pane fade ">
                <div class="table-responsive report-table-wrp">
                    <table class="table report-table report-day" id="dayTable">
                        <thead>
                            <tr>
                                <th>Employees</th>
                                <th>Punch In</th>
                                <th>Punch In Note</th>
                                <th>Punch Out</th>
                                <th>Punch Out Note</th>
                                <th>Duration</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="NotFound">
                                <td colspan="6" class="text-center">No Employee Found</td>
                            </tr>

                            <tr v-for="(user,Windex) of users" :key="Windex">
                                <td>
                                    <div class="empl-info">
                                        <div class="avtar">
                                            <a href="#" v-if="user.image !== ''"><img :src="$API_URL+'storage/'+user.image" @error="imageNotFound" alt="Profile image" width="50" height="50"></a>
                                            <span v-if="user.image === ''" class="profile-name text-uppercase">
                                                {{ getNameIfNotImage(user.name) }}
                                            </span>
                                            <span v-show="user.image !== '' && imgNotFnd" class="profile-name text-uppercase">
                                                {{ getNameIfNotImage(user.name) }}
                                            </span>
                                        </div>
                                        <div class="empl-descrip">
                                            <strong class="emp-name text-capitalize"><a href="">{{ user.name }}</a></strong>
                                            <div class="emp-designation">
                                                <span v-for="role of user.employeeJobType" :key="role.id"><i class="ico ico-fill-circle" :style="{color:role.get_job_roles !== null? role.get_job_roles.color: '',}"></i>
                                                    {{ role.get_job_roles.name || '' }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td v-if="user.today_record.length !== 0">
                                    {{ moment(user.today_record.punch_in).format('hh:mm A') }}
                                </td>
                                <td v-else>00:00</td>

                                <td v-if="user.today_record.length !== 0"> {{ user.today_record.punch_in_note }} </td>
                                <td v-else></td>

                                <td v-if="user.today_record.length !== 0">
                                    <span v-if="user.today_record.punch_out_time === null">00:00</span>
                                    <span v-else>
                                        {{ moment(user.today_record.punch_out_time).format('hh:mm A') }}
                                    </span>
                                </td>
                                <td v-else>00:00</td>

                                <td v-if="user.today_record.length !== 0"> {{ user.today_record.punch_out_note }} </td>
                                <td v-else> {{ user.today_record.punch_out_note }} </td>

                                <td v-if="user.today_record.length !== 0">
                                    <span v-if="user.today_record.punch_out === null">
                                        {{ calculateHoursM(user.today_record) }}
                                    </span>
                                    <span v-else>
                                        {{ calculateHoursM(user.today_record) }}
                                    </span>
                                </td>
                                <td v-else>00:00</td>
                            </tr>
                            <tr v-show="loadingSpin">
                                <td colspan="6" class="text-center">
                                    <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="inf-week" class="tab-pane fade">
                <div class="table-responsive report-table-wrp">
                    <table class="table report-table report-day" id="weekTable">
                        <thead>
                            <tr>
                                <th>Employees</th>
                                <th v-for="(wday,wInd) of weekDates" :key="wInd">
                                    <span class="d-block">{{ wday.day_name }}</span>
                                    <span class="d-block">{{ wday.day_num }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="NotFound">
                                <td colspan="8" class="text-center">No Employee Found</td>
                            </tr>
                            <tr v-show="loadingSpin">
                                <td :colspan="weekDates.length + 3" class="text-center">
                                    <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
                                </td>
                            </tr>
                            <tr v-for="(user,Windex) of users" :key="Windex">
                                <td>
                                    <div class="empl-info">
                                        <div class="avtar">
                                            <a href="#" v-if="user.image !== ''"><img :src="$API_URL+'storage/'+user.image" @error="imageNotFound" alt="Profile image" width="50" height="50"></a>
                                            <span v-if="user.image === ''" class="profile-name text-uppercase">
                                                {{ getNameIfNotImage(user.name) }}
                                            </span>
                                            <span v-show="user.image !== '' && imgNotFnd" class="profile-name text-uppercase">
                                                {{ getNameIfNotImage(user.name) }}
                                            </span>
                                        </div>
                                        <div class="empl-descrip">
                                            <strong class="emp-name text-capitalize"><a href="">{{ user.name }}</a></strong>
                                            <div class="emp-designation">
                                                <span v-for="role of user.employeeJobType" :key="role.id">
                                                    <i class="ico ico-fill-circle" :style="{color:role.get_job_roles !== null? role.get_job_roles.color: ''}"></i>
                                                    {{ role.get_job_roles.name }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td v-for="(attnd,ind) of Object.entries(user.weekly_record).slice(0, 7)" :key="ind" :class="{weekColumColor:ind==dateIndexNew}">
                                    <small v-if="attnd[1]['typePresent'] === 'present' || attnd[1]['typePresent'] === 'Leave/Present' ||
                     attnd[1]['typePresent'] === 'Present/Leave' || attnd[1] === 'Present'">
                                        {{ timeFormat(attnd[1]['attendancePunchInTime']) }}
                                        <br>
                                    </small>
                                    <span class="inf-circle absent" v-if="attnd === 'Absent'">A</span>
                                    <span class="inf-circle present" v-else-if="attnd[1]['typePresent'] === 'present' || attnd[1] === 'Present'">P</span>
                                    <span class="inf-circle absent" v-else-if="attnd[1] === 'NotShift'"></span>
                                    <span class="inf-circle weekend" v-else-if="attnd[1] === 'Leave'">L</span>
                                    <span class="inf-circle holiday" v-else-if="attnd[1]['typePresent'] === 'Leave/Present' || attnd[1] === 'Leave/Present'">L/P</span>
                                    <span class="inf-circle holiday" v-else-if="attnd[1]['typePresent'] === 'Present/Leave' || attnd[1] === 'Present/Leave'">P/L</span>
                                    <span class="" v-else-if="attnd[1] === 'Time'"> {{ user.sche_st_time_arr }} </span>
                                    <span class="" v-else-if="attnd[1] === 'Blank'"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="inf-month" class="tab-pane fade show active">
                <div class="table-responsive report-table-wrp">
                    <table class="table report-table report-day" id="monthTable">
                        <thead>
                            <tr>
                                <th class="firstColName">Employees</th>
                                <th v-for="(day,indd) of monthDates" :key="indd">
                                    <span class="d-block">{{ day.day_name }}</span>
                                    <span class="d-block">{{ day.day_num }}</span>
                                </th>
                                <th>
                                    <span class="d-block">Absent</span>
                                </th>
                                <th>
                                    <span class="d-block">Day</span>
                                    <span class="d-block">Work</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="NotFound">
                                <td :colspan="monthDates.length + 3" class="text-center">No Employee Found</td>
                            </tr>
                            <tr v-show="loadingSpin">
                                <td :colspan="monthDates.length + 3" class="text-center">
                                    <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
                                </td>
                            </tr>
                            <tr v-for="(user,index) of users" :key="index">
                                <td class="firstCol">
                                    <div class="empl-info">
                                        <div class="avtar">
                                            <a href="javascript:void(0);" v-if="user.image !== ''">
                                                <img :src="$API_URL+'storage/'+user.image" @error="imageNotFound" alt="Profile image" width="50" height="50">
                                            </a>
                                            <span v-if="user.image === ''" class="profile-name text-uppercase">
                                                {{ getNameIfNotImage(user.name) }}
                                            </span>
                                            <span v-show="user.image !== '' && imgNotFnd" class="profile-name text-uppercase">
                                                {{ getNameIfNotImage(user.name) }}
                                            </span>
                                        </div>
                                        <div class="empl-descrip">
                                            <router-link :to="{ path: '/employee/profile/' + user.uuid + '' }">
                                                <strong class="emp-name text-capitalize" @click="setUserData(user)">{{ user.name }}</strong>
                                            </router-link>
                                            <div class="emp-designation">
                                                <span v-for="role of user.employeeJobType" :key="role.id" v-if="user.employeeJobType.length>0">
                                                    <i class="ico ico-fill-circle" :style="{color:role.get_job_roles !== null? role.get_job_roles.color: ''}"></i>
                                                    {{ role.get_job_roles.name }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td v-for="(attnd,ind, columnIndex) of user.employee_record" :key="ind" :class="{monthColumColor:columnIndex==dateIndex}" style="position: relative">
<!--                                  <small v-if="attnd['punchOutNote'] == 'Auto Punch Out'" class="autoPunchOut">Auto</small>-->
<!--                                  <pre> <code> {{attnd}}</code> </pre>-->
                                    <small v-if="attnd['typePresent'] === 'present' || attnd['typePresent'] === 'Leave/Present' ||
                                     attnd['typePresent'] === 'Present/Leave' || attnd === 'Present'">
                                       {{timeFormat(attnd['attendancePunchInTime'])}}
                                        <br>
                                    </small>
                                    <span class="inf-circle absent" v-if="attnd === 'Absent'">A</span>
                                    <span class="inf-circle present" v-else-if="attnd['typePresent'] === 'present' || attnd === 'Present'">P</span>
                                    <span class="inf-circle absent" v-else-if="attnd === 'NotShift'"></span>
                                    <span class="inf-circle weekend" v-else-if="attnd === 'Leave'">L</span>
                                    <span class="inf-circle holiday" v-else-if="attnd['typePresent'] === 'Leave/Present' || attnd === 'Leave/Present'">L/P</span>
                                    <span class="inf-circle holiday" v-else-if="attnd['typePresent'] === 'Present/Leave' || attnd === 'Present/Leave'">P/L</span>
                                    <span class="" v-else-if="attnd === 'Time'"> {{ user.sche_st_time_arr }} </span>
                                    <span class="" v-else-if="attnd === 'Blank'"></span>
                                  <small v-if="attnd['typePresent'] === 'present' || attnd['typePresent'] === 'Leave/Present' ||
                                     attnd['typePresent'] === 'Present/Leave' || attnd === 'Present'">
                                    {{(attnd['punchOutTime'] !='')?timeFormat(attnd['punchOutTime']):''}}
                                    <br>
                                  </small>
                                </td>
                                <td><span class="inf-circle">{{ user.workStatus.absent }}</span></td>
                                <td><span class="inf-circle">{{ user.workStatus.present }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- <div class="mt-10" v-show="loadMoreCheck && users.length>=15">
          <a href="javascript:void(0);" class="btn btn-outline-primary" @click="loadMoreAttendances">Load All</a>
        </div> -->
        <div class="report-tfoot">
            <div class="container">
                <ul class="rep-info">
                    <li class="present">P - Present / Late Arrival</li>
                    <li class="absent">A - Absent</li>
                    <li class="weekend">L - Leave</li>
                    <li class="holiday">P/L - Present/Leave & L/P - Leave/Present</li>
                    <li class="holiday">WH - Work From Home</li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import collect from "collect.js";

export default {
    components: {
        DatePicker,
        ClipLoader
    },
    data() {
        return {
            attendanceTypes: ['All', 'Present', 'Absent', 'NotShift', 'Leave', 'Leave/Present', 'Present/Leave', 'Work From Home', 'Late Arrival'],
            users: [],
            totalUsers: [],
            users2: [],
            monthDates: [],
            weekDates: [],
            dateFilter: new Date(),
            roleColor: '',
            tableId: 'monthTable',
            selectedCompany: this.$store.getters.getSelectedCompany,
            imgNotFnd: false,
            size: '25px',
            spinnerColor: '#00779C',
            loadingSpin: false,
            NotFound: false,
            currentDate: new Date(),
            search: '',
            page: 1,
            loadMoreCheck: true,
            selectAttendaceStatus: 'Select Attendance Status',
            dateIndex: (new Date().getDate() - 1),
            dateIndexNew: (new Date().getDay() + 6) % 7,
        }
    },
    computed: {

    sortedJobRoles() {
            return this.selectedCompany.jobRoles.slice().sort((a, b) => a.name.localeCompare(b.name));
        }
    },
    created() {
        this.currentDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + (new Date().getDate() - 1);
        this.weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    },
    mounted() {
        this.getCurrentMonthDates();
        this.getEmployeesWithAttendance();
    },

    methods: {
        filterAttendanceStatus(typeSt) {
            let type = typeSt;
            this.selectAttendaceStatus = type;
            if (type === 'All') {
                this.users = this.users2;
                this.NotFound = false;
                return;
            }
            this.users = [];
            this.users = this.users2.filter((user) => {
                const {
                    employee_record
                } = user;
                const selectedDate = moment(this.dateFilter).format('YYYY-MM-D');
                if (!type && !selectedDate) return true;
                if (type === 'Work From Home' && user.remoteWork == 'yes') {
                    return user;
                }
                for (const date in employee_record) {
                    const data = employee_record[date];
                    if (date && selectedDate && data) {
                        if ((date === selectedDate) && (data.typePresent != undefined) && type === 'Late Arrival') {
                            if (data.typePresent.toLowerCase() === 'present') {

                                if (this.checkLateArrival(user.schedules, selectedDate, data).length > 0) {
                                    return user;
                                }
                            }
                        }
                        if ((date === selectedDate) && ((data.typePresent != undefined && data.typePresent.toLowerCase() === type.toLowerCase()) || (data != undefined && data === type))) {
                            return user;
                        }
                    }
                }
                return false;
            });
            this.NotFound = this.users.length === 0;
        },
        checkLateArrival(shifts, date, data) {
            return shifts.filter((shift) => {
                if (shift.date === moment(this.dateFilter).format('YYYY-MM-DD')) {
                    const shiftDateTime = shift.date + ' ' + shift.start_time;
                    const shiftStartDateTime = new Date(shiftDateTime);
                    const punchInDateTime = new Date(data.attendancePunchInTime);
                    shiftStartDateTime.setMinutes(shiftStartDateTime.getMinutes() + 30);
                    const momentShiftStart = moment(shiftStartDateTime);
                    const momentPunchIn = moment(punchInDateTime);
                    return momentPunchIn.isAfter(momentShiftStart);
                }
            });
        },

        timeFormat(dateTime) {
            return moment(dateTime).format('HH:mm');
        },
        setUserData(user) {
            this.$store.commit('setEmployeeProfileId', user);
        },
        changeTableId(tableId) {
            this.tableId = tableId;
        },
        imageNotFound(event) {
            if (event.type === 'error') {
                $(event.target).remove();
                this.imgNotFnd = true;
            }
        },
        exportxlsx() {
            let tableClone = $('#' + this.tableId).clone();
            tableClone.find(".avtar").each(function () {
                $(this).remove();
            });

            var tab = tableClone[0];
            var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
            for (let j = 0; j < tab.rows.length; j++) {
                tab_text += tab.rows[j].innerHTML + "</tr>";
            }

            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                // If Internet Explorer
                txtArea1.document.open("txt/html", "replace");
                txtArea1.document.write(tab_text);
                txtArea1.document.close();
                txtArea1.focus();
                sa = txtArea1.document.execCommand("SaveAs", true, "Thanks.xls");

            } else {
                let a = $("<a />", {
                    href: "data:application/vnd.ms-excel," + encodeURIComponent(tab_text),
                    download: "MonthlyAttendanceRecord.xls",
                }).appendTo("body").get(0).click();
            }
        },
        searchByName() {
        this.users = this.users2;
        collect().macro("whereLike", function (search) {
            var searched = new RegExp(search, "i");
            return this.filter((item) =>
                searched.test(item.name)
            );
        });
        if (this.search !== '') {
            const searchRegex = new RegExp(this.search.trim(), "i");
                    this.users = this.users2.filter(user => searchRegex.test(user.name));
                    if (this.users.length === 0) {
                        this.NotFound = true;
                    } else {
                        this.NotFound = false;
                    }
                } else {
                    this.NotFound = false;
                }
        },
        filterByJobType(id, color, name) {
            let tagName = $('.roleName')[0];
            this.loadMoreCheck = false;
            tagName.innerText = name;
            this.roleColor = color;

            this.users = this.users2.filter(item => {
                return item.employeeJobType.some(job => job.job_role_id === id);
            });
            if (this.users.length === 0) {
                this.users = [];
                this.NotFound = true;
            } else {
                this.NotFound = false;
            }
        },

        allEmployeeAfterFilter() {
            $('.roleName')[0].innerText = 'Select job type';
            this.roleColor = '';
            this.users = this.users2;
            if (this.NotFound) {
             this.NotFound = false;
            }
        },
        filterEmployeesByAttendanceStatus() {
            $('.statusName')[0].innerText = 'Select Attendance Status';
            this.roleColor = '';
            this.users = this.users2;

        },
        filterAttendance(event) {
            this.users = [];
            let filteredDate = this.dateFilter;
            this.dateIndex = (new Date(this.dateFilter).getDate() - 1);
            this.dateIndexNew = (new Date(this.dateFilter).getDay() + 6) % 7;
            this.getEmployeesWithAttendance(filteredDate);
            this.selectAttendaceStatus = 'All';
        },
        getNameIfNotImage(name) {
            return this.getNameFirstLetter(name);
        },
        calculateHoursM(attendance) {
            return this.calculateAttendanceTimes(attendance);
        },

        getCurrentMonthDates(dateArgu = new Date()) {

            this.monthDates = [];
            this.weekDates = [];
            var date = new Date(dateArgu);
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            for (let i = firstDay.getDate(); i <= lastDay.getDate(); i++) {
                let dateObj = new Date(date.getFullYear(), date.getMonth(), i);
                let daysNum = dateObj.getDate();
                if (daysNum < 10) {
                    daysNum = '0' + daysNum;
                }
                let obj = {
                    day_name: this.weekDays[dateObj.getDay()],
                    day_num: daysNum
                }
                this.monthDates.push(obj);
            }

        },
        // loadMoreAttendances(){
        //   this.loadingSpin = true;
        //   this.$axios({
        //     method: "get",
        //     params: {
        //       company_id  : this.selectedCompany.id,
        //       date        : this.dateFilter,
        //       page        : 'all'
        //     },
        //     url     : this.$getEmployeeWithAttendanceReport,
        //     headers : this.getAuthHeader(),
        //   }).then((res) => {
        //     if (res.data.status == 200) {
        //       this.loadMoreCheck = false
        //       // this.users = [...this.users,...res.data.result.user];
        //       this.users = res.data.result.user;
        //       this.loadingSpin = false;
        //     }
        //   });
        //   this.loadingSpin = false;
        // },
        getEmployeesWithAttendance(date = new Date()) {
            this.loadingSpin = true;
            this.$axios({
                method: "get",
                params: {
                    company_id: this.selectedCompany.id,
                    date: date
                },
                url: this.$getEmployeeWithAttendanceReport,
                headers: this.getAuthHeader()
            }).then(res => {
                if (res.data.status == 200) {
                    this.users = res.data.result.user;
                    this.users2 = this.users;
                    this.loadingSpin = false;
                    this.NotFound = this.users.length === 0 ? true : false;
                    this.getCurrentMonthDates(date);
                    if (this.users.length !== 0) {
                        let wek_dts = this.users[0].weekly_record;
                        let iterationCount = 0;
                        Object.keys(wek_dts).map(dt => {
                            if (iterationCount >= 7) return;
                            let wDate = new Date(dt);
                            let day_num = ('0' + wDate.getDate()).slice(-2);
                            let obj = {
                                day_name: this.weekDays[wDate.getDay()],
                                day_num: day_num
                            };
                            this.weekDates.push(obj);
                            iterationCount++;
                        });
                    }
                    // this.getTotalEmployeesWithAttendance(date);
                }
            });
        },
        getTotalEmployeesWithAttendance(date = new Date()) {
            this.$axios({
                method: "get",
                params: {
                    company_id: this.selectedCompany.id,
                    date: date
                },
                url: this.$TotalgetEmployeeWithAttendanceReport,
                headers: this.getAuthHeader()
            }).then(res => {
                if (res.data.status == 200) {
                    this.totalUsers = res.data.result.user;
                }
            });
        }
    }
}
</script>

<style scoped>
.report-table .empl-info .avtar {
    position: relative;
}

.profile-name {
    position: absolute;
    top: 3px;
    left: 4px;
    font-size: 10px
}

.textBlack {
    color: black !important;
}

.hover-bg:hover {
    background-color: #e6eaeb;
    font-weight: bold ;
}

.monthColumColor {
    background-color: #e8e9e8;
}

.weekColumColor {
    background-color: #f2f3f2;
}

.bullet {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
    background-color: rgb(206, 206, 206);
}
.report-table td{
  padding: 4px 6.7px;
}
.autoPunchOut {
  background: red;
  color: white;
  border-radius: 21%;
  display: inline-block;
  writing-mode: vertical-rl; /* This sets the text orientation to vertical */
  text-orientation: upright; /* Ensures that the text is not rotated */
  position: absolute;
  top: 6px;
  width: 15px;
  left: 0px;
}
</style>
